module.exports = __webpack_public_path__ + "media/images/logos/windeurope-tech2025-1fce3e716439df595b7ecd27ae41ff50.svg";